export default __webpack_public_path__ + "static/media/likes.5b1d8ef1.svg";